import Dropdown, { IDropdownItem, IDropdownProps } from "@/core/components/dropdown";
import { WarningCircleIcon } from "@phosphor-icons/react";
import React from "react";

interface IFormItemProps {
  name: string,
  label?: string,
  options: IDropdownItem[],
  placeholder?: string,
  errors?: any,
  disabled?: boolean,
  onChange?: (value: any) => void,
  closeEnable?: boolean
}

const Select = React.forwardRef<HTMLDivElement, IFormItemProps & Omit<IDropdownProps, "dataSource" | "onChange">>(
  ({ name, label, placeholder, options, errors, disabled, onChange, closeEnable, ...dropdownProps }, ref) => {
    return (
      <div ref={ref} className={`dv-form__select ${errors?.[name]?.message ? 'dv-form__select--error' : ''}`}>
        <label>{label}</label>
        <Dropdown
          dataSource={options}
          placeholder={placeholder}
          disabled={disabled}
          onChange={onChange}
          closeEnable={closeEnable}
          {...dropdownProps}
        />
        {
          errors?.[name]?.message &&
          <div className="danger-text">
            <WarningCircleIcon size={16} />{errors?.[name]?.message}
          </div>
        }
      </div>
    )
  }
);

export default Select;
